export default __webpack_public_path__ + "static/media/DailyBruinLogo.a9b47090.svg";